<script setup lang="ts">
import { RouterLink } from 'vue-router';
import { useI18n } from 'vue-i18n';

import { UiAppPage, UiButton, UiEmptyState } from '@ohmybible/ui';

import { usePageTitle } from '@/shared/composables/usePageTitle';

const { t } = useI18n();

usePageTitle(() => t('errors.notFound.documentTitle'));
</script>

<template>
  <UiAppPage data-testid="not-found-page">
    <UiEmptyState
      :heading-level="1"
      :title="t('errors.notFound.title')"
      :description="t('errors.notFound.description')"
    >
      <template #actions>
        <UiButton
          :as="RouterLink"
          to="/"
          variant="soft"
          data-testid="not-found-home"
        >
          {{ t('errors.notFound.home') }}
        </UiButton>
      </template>
    </UiEmptyState>
  </UiAppPage>
</template>
